/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import CheckBoxInput from '../common/CheckBoxInput';
import Button from '../common/Button';
import {Link} from 'react-router';
import {ITAAlert} from '../common/ITAAlert';
import * as pathConstants from '../../constants/pathConstants';
import '../../styles/fileUpload/FileUploadForm.css';
import * as FileUploadConstants from '../../constants/fileUploadConstants';

const CaseDataFileUploadForm = ({
                          form,
                          uploadFile,
                          onSubmit,
                          onClick,
                          onCancel,
                          formIsValid,
                          uploadFailed,
                          fileUploadAgreement,
                          error,
                          downloadUrl
                        }) => {
  let questions = [];
  if (form.formQuestions) {
    form.formQuestions.forEach(question => {
      let questionParts = [];
      question.questionParts.map(questionPart => {
        let type = questionPart.questionPartType;
        if (type === '1') {
          questionParts.push(
            <span className="question-part"
                  key={questionPart.questionPartName}>
                <CheckBoxInput
                  name=""
                  label={questionPart.questionPartLabel}
                  options={questionPart.questionPartOptions}
                  onChange={onClick}
                  checked={fileUploadAgreement}
                />
              </span>
          );
        }
      });
      questions.push(
        <span className="question"
              key={question.questionID || question.questionName}>
          {question.questionGroupHelpText &&
          <div
            dangerouslySetInnerHTML={{__html: question.questionGroupHelpText}}/>}
          {questionParts}
        </span>
      );
    });
  }
  return (
    <div id="file-upload-panel">
      <div className="panel-heading row">
        <div className="alert alert-danger" hidden={!error}>
          <div className="first-line">{error}</div>
          <div className="second-line" hidden={!downloadUrl}>{FileUploadConstants.ALTERNATIVE_CLEANED_FILE} <a href={downloadUrl} download="cleaned_file.csv">here</a></div>
        </div>
        {!uploadFailed &&
        <ITAAlert style="success"
                  message={
                    <div className="first-line">
                      Your file was successfully submitted, you will receive <em className="text-underline"><strong>two</strong></em> emails once it has been successfully processed. If you do not receive the <em className="text-underline">second</em> e-mail, your file DID NOT properly load. <span className="text-normal">Visit the FAQs guidance on common errors that block a file from loading</span>.
                    </div>
                  }/>
        }
        <div className=" mobile-warning">
          <ITAAlert style="warning"
                    message={
                      <div className="first-line">
                        This feature may not work on your device.
                      </div>
                    }/>
        </div>

      </div>
      <div>
        <p>
          This page allows you to batch upload 300/301 data for one or many establishments
          you have created. You can use this page to submit and re-submit 300/301 data by
          following the steps listed below.
        </p>
        <p>
          For more information,
          see <a href='https://www.osha.gov/injuryreporting/faqs' target='_blank' rel='noopener noreferrer'>Frequently Asked Questions (FAQ)</a> related
          to CSV files. If you encounter any issues uploading your file, submit
          a request to the ITA Help Desk by completing the form located <Link to={pathConstants.pathToHelpRequest}>here</Link>.
        </p>
        <p>
          Please note, if you are submitting data for one or a small number of establishments,
          it is easier to manually enter the data using the web forms rather than creating
          and uploading a CSV file. See the job aid '<a href="https://www.osha.gov/sites/default/files/manually-add-300-301-data.pdf"
          target="_blank" title="Instructions for Manually adding 300/301 data - PDF">Manual Submission for 300/301 data</a>'.
        </p>
        <p>
          Please ensure your 300A CSV file upload has been processed before submitting a 300/301 CSV file.
          You will get a confirmation email after the 300A CSV submission has been processed.
          If your 300A data has not completed processing, the 300/301 upload will not succeed.
        </p>
      </div>
      <div className="file-upload-section">
        <form>
          <div className="step row">
            <div className="col-xs-12">
              <h2> Step 1: Read the Instructions </h2>
              <div>In order for your file to be processed correctly, the establishment must have
                submitted 300A data, and it must contain the 300 Log and 301 Incident Report Summary
                data in a specific format.
              </div>
              <br/>
              <div>The instructions for creating a file can be found here: <a
                href="https://www.osha.gov/sites/default/files/ita_case_data_csv_specifications.pdf"
                target="_blank">File Instructions</a></div>
              <br/>
              <div>A template file can be downloaded here: <a
                href="https://www.osha.gov/sites/default/files/ita_template_form_300-301_csv_data.csv"
                target="_blank">CSV Template</a></div>
              <br/>
              <div>A sample CSV file can be downloaded here: <a
                href="https://www.osha.gov/sites/default/files/ita_sample_form_300-301_csv_data.csv"
                target="_blank">CSV Sample</a></div>
              <br/>
              <div>File size cannot exceed 20 MB. For larger files, please split into 20 MB files.</div>
            </div>
          </div>
          <div className="step row">
            <div className="col-xs-12">
              <h2> Step 2: Locate and Select Your File </h2>
              <input type="file" id="file-upload" onChange={uploadFile}/>
            </div>
          </div>
          <div className="step row">
            <div className="col-xs-12">
              {questions}
            </div>
          </div>
          <div className="step row">
              <span className="col-xs-12" id="fileUpload">
                <h2> Step 4: Upload Your File </h2>
                <div>Select "Upload" button to upload your file. Submitting your 300/301 data by CSV file will
                  generate <em>two</em> confirmation e-mails. One email will confirm your submission, the other
                  will indicate a status of success or failure. If you do not receive the second e-mail, your
                  data <em>DID NOT</em> properly load.</div>
                <div className="button-container">
                  <Button
                    className="submit-file pull-right"
                    value="Upload"
                    disabled={!formIsValid}
                    onClick={onSubmit}/>
                  <a
                    className="btn btn-cancel cancel-file pull-right"
                    disabled={false}
                    href="#"
                    onClick={onCancel}>
                    Cancel
                  </a>
                </div>
              </span>
          </div>
        </form>
      </div>
    </div>
  );
};

CaseDataFileUploadForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  uploadFile: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  formIsValid: PropTypes.bool.isRequired,
  uploadFailed: PropTypes.bool.isRequired,
  fileUploadAgreement: PropTypes.bool.isRequired,
  error: PropTypes.string,
  downloadUrl: PropTypes.string
};

export default CaseDataFileUploadForm;



/** WEBPACK FOOTER **
 ** ./src/components/fileUpload/CaseDataFileUploadForm.js
 **/